import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { faChevronRight, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { ConnectionsService } from 'src/app/services/connections.service';
import * as XLSX from 'xlsx';
import { HistoryDetailService } from 'src/app/services/history-detail.service';
import { CommonConstant } from '../../core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { AetStateService } from 'src/app/services/aet-state.service';
import { ExcelService } from 'src/app/services/excel.service';
import moment from 'moment';
import { EditEventComponent } from 'src/app/core/check/edit-event/edit-event.component';
import { LegendsComponent } from '../history/legends/legends.component';
import {EventEditHistoryComponent} from 'src/app/pages/event-edit-history/event-edit-history.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-event-details',
    templateUrl: './event-details.component.html',
    styleUrls: ['./event-details.component.scss'],
    standalone: false // NOSONAR
})
export class EventDetailsComponent implements OnInit {

  menuVariable: boolean = false;
  faChevronRight = faChevronRight;
  faFileExcel = faFileExcel;
  connectionsShow: any = false
  historyRowData: any;
  @Input('conn') conn : boolean ; // NOSONAR
  @Input('reOpen') reOpen : boolean ; // NOSONAR
  @Input() message : any;
  eventId: any
  name: any;
  successMessage: any;
  errorMessage: any;
  isAccessible: boolean = true;
  gpsCheck: boolean = false;
  historylinks = {
    eventsdetail: ["/history/event"],
    resolutions: ["/history/resolutions"],
    connections: ["/history/connections"],
    eventhistory: ["/history/event-history"],
  }
  dashboardlinks = {
    eventsdetail: ["/dashboard/event"],
    resolutions: ["/dashboard/resolutions"],
    connections: ["/dashboard/connections"],
    eventhistory: ["/dashboard/event-history"],
  }
  activeLinks = {
    eventsdetail: [],
    resolutions: [],
    connections: [],
    eventhistory: [],
  }
  fromDashboard = false;


  openMenu() {
    this.menuVariable = !this.menuVariable;
  }
  @Output() updateEvent = new EventEmitter();
  constructor(
      private readonly dialog : MatDialog, private readonly connectionsService : ConnectionsService, private readonly history: HistoryDetailService,
     private readonly aetStateService : AetStateService, private readonly excelService :ExcelService, private readonly router: Router,public constants: Constants,  private readonly route : ActivatedRoute) { }

  ngOnInit(): void {
    // this.checkRoles();
    this.name = this.history.name;
    this.historyRowData = this.name.source._value;
    this.eventId = '';
    if(localStorage.getItem('eventId')) {
      this.eventId = localStorage.getItem('eventId');
    }
    this.fromDashboard = this.route.snapshot.pathFromRoot.flatMap((val)=> val.url.join('')).join('/').includes('dashboard');
    if (this.fromDashboard) {
      this.activeLinks = {...this.dashboardlinks};
      this.gpsCheck = true;
    } else {
      this.activeLinks = {...this.historylinks};
      this.gpsCheck = false;
    }
    this.reOpen = false;
    
  }

  openEditEvent(){
    this.dialog?.open(EditEventComponent, {
      width: '850px',
      height: '600px',
      panelClass: 'edit-event-mat-dialog'
    })
  }

  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON.parse(roles);
    
    if (
      (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
      userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
      userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
      userRoles.includes(this.constants.LIOS_UAC_General_User)
    ) {
      if (
        (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
        userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_AET_LP)
      ) {
        this.isAccessible = true;
       
      }
    } else {
      this.router.navigate([`/home`]);
    }

  }

  downloadConnections() {
    
    const headers = [
        'IMPACTED',
        'CURRENT ROUTE',
        'SUPPLIER',
        'CA CODE',
        'MTM CODE',
        'PLANT',
        'DOCK',
        'ORDER',
        'ROUTE 1',
        'REGION',
        'CD1 U/L',
        'ROUTE 2',
        'REGION',
        'CD1 R/L',
        'CD2 U/L',
        'ROUTE 3',
        'REGION',
        'CD2 R/L',
        'CD3 U/L',
        'ROUTE 4',
        'REGION',
        'CD3 R/L',
        'CD4 U/L',
        'PLANT U/L',
      ];
    const exportData = [];
    const date_frmt = 'MM/DD/YYYY HH:mm'
    this.message.forEach((e) => {
      const obj = {
        IMPACTED:e.is_impacted,
        CURRENT_ROUTE: e.current_route,
        SUPPLIER: e.supplier_id,
        CA_CODE: e.ca_code,
        MTM_CODE: e.mtm_code,
        PLANT: e.plant_id,
        DOCK: e.logical_dock_id,
        ORDER: e.order_number,
        ROUTE: e.route_1,
        REGION: e.route_1_region,
        CD1_UL: (e.route_1_unload)? moment(e.route_1_unload).format(date_frmt): "",
        ROUTE2: e.route_2,
        REGION2: e.route_2_region,
        CD1_RL: (e.route_1_reload)? moment(e.route_1_reload).format(date_frmt): "",
        CD2UL: (e.route_2_unload)? moment(e.route_2_unload).format(date_frmt): "",
        ROUTE3: e.route_3,
        REGION3: e.route_3_region,
        CD2RL: (e.route_2_reload)? moment(e.route_2_reload).format(date_frmt): "",
        CD3UL: (e.route_3_unload)? moment(e.route_3_unload).format(date_frmt): "",
        ROUTE4: e.route_4,
        REGION4: e.route_4_region,
        CD3_RL: (e.route_3_reload)? moment(e.route_3_reload).format(date_frmt): "",
        CD4_UL: (e.route_4_unload)? moment(e.route_4_unload).format(date_frmt): "",
        PLANT_UL: (e.plant_unload)? moment(e.plant_unload).format(date_frmt): "",
      };

      exportData.push(obj);
    });
    this.excelService.exportAsExcelFile(exportData, 'getDetailedConnections', headers);
  }

  close() {
    this.errorMessage = null;
    this.successMessage = null;
  }

  openLegends() {
    this.dialog?.open(LegendsComponent, {
      width: '540px',
      height: '290px'
    })
  }

  reOpenHistory() {
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    this.successMessage = null;
    this.errorMessage = null;
    this.connectionsService.reopen(this.eventId, toyotaGUID).subscribe({
      next: (res: any) => {
        this.successMessage = CommonConstant.reOpenSuccess;
        this.updateEvent.emit(res);
      },
      error: (_error) => {
        
        this.errorMessage = CommonConstant.reOpenFailure;
      }
    })
  }

  onBacktoDashboard() {
    localStorage.setItem('backFlag','true');
    this.router.navigate(['/dashboard']);
  }

  viewHistory() {
    this.dialog?.open(EventEditHistoryComponent, {
      width: '1100px',
      height: '430px'
    });
  }
}
